import type { PaymentInfo } from '../data/receipt';

const typeLabels: Record<string, string> = {
  cash: 'Cash',
  card: 'Card',
  check: 'Check',
  gift_card: 'Gift Card',
  other: 'Other',
};

export function formatPayment(payment: PaymentInfo | undefined): string {
  if (!payment) {
    return '';
  }

  if (payment.type === 'card') {
    const brand = payment.card_brand || 'Card';
    if (payment.card_last4) {
      return `${brand} • ${payment.card_last4}`;
    }

    return brand;
  }

  return typeLabels[payment.type] ?? 'Other';
}

export function formatPaymentLabel(
  payment: PaymentInfo | undefined,
  payment2: PaymentInfo | undefined
): string {
  const primary = formatPayment(payment);
  if (!primary) {
    return '';
  }

  const secondary = formatPayment(payment2);
  if (!secondary) {
    return primary;
  }

  return `${primary} + ${secondary}`;
}
